import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import {IProduct} from '@/shared/model/product.model';

const baseApiUrl = 'api/products';

export default class ProductService {
    public find(id): Promise<IProduct> {
        return new Promise<IProduct>(resolve => {
            axios.get(`${baseApiUrl}/${id}`).then(function (res) {
                resolve(res.data);
            });
        });
    }

    public retrieve(paginationQuery?: any, search?: IProduct): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            let url = `${baseApiUrl}?`;
            if (search.installationId) {
                url = `${url}installationId.equals=${search.installationId}&`;
            }
            if (search.customer) {
                url = `${url}customer.contains=${search.customer}&`;
            }
            if (search.product) {
                url = `${url}product.contains=${search.product}&`;
            }
            if (search.name) {
                url = `${url}name.contains=${search.name}&`;
            }
            if (search.sender) {
                url = `${url}sender.contains=${search.sender}&`;
            }
            if (search.search) {
                url = `${url}search.contains=${search.search}&`;
            }
            if (search.license) {
                url = `${url}license.contains=${search.license}&`;
            }
            if (search.includeIntoAggregateReport != undefined) {
                url = `${url}includeIntoAggregateReport.equals=${search.includeIntoAggregateReport}&`;
            }
            axios.get(url + `${buildPaginationQueryOpts(paginationQuery)}`).then(function (res) {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    }

    public create(entity): Promise<IProduct> {
        return new Promise<IProduct>(resolve => {
            axios.post(`${baseApiUrl}`, entity).then(function (res) {
                resolve(res.data);
            });
        });
    }

    public update(entity): Promise<IProduct> {
        return new Promise<IProduct>(resolve => {
            axios.put(`${baseApiUrl}`, entity).then(function (res) {
                resolve(res.data);
            });
        });
    }

    public retrieveCustomerNames(): Promise<any> {
        return new Promise<any>(resolve => {
            axios.get(baseApiUrl + `/customers`).then(function (res) {
                resolve(res);
            });
        });
    }

    public retrieveProductNames(): Promise<any> {
        return new Promise<any>(resolve => {
            axios.get(baseApiUrl + `/names`).then(function (res) {
                resolve(res);
            });
        });
    }
}
